<dx-popup #popup [fullScreen]="false" [showTitle]="true" [dragEnabled]="true" [hideOnOutsideClick]="false"
  [showCloseButton]="true" title="Stapelberechnung" width="480" height="auto" [disabled]="isLoading" (onShown)="onShown($event)" (onHidden)="onHidden($event)">
  <div *dxTemplate="let data of 'content'" class="popup-content">
    <dx-form #editForm [formData]="formData" class="stapelbearbeitung-form">
      <dxi-item  [colSpan]="2">
        <span>Berechnungsperiode</span>
      </dxi-item>
      <dxi-item itemType="group" [colCount]="2">
        <!-- <dxi-item dataField="monat" editorType="dxNumberBox" [label]="{ text: '' }" [editorOptions]="{ value: formData.monat, min: 1, max: 12, showClearButton: false}"
        [isRequired]="true" >
      </dxi-item>
      <dxi-item dataField="jahr" editorType="dxNumberBox" [label]="{ text: '' }" [editorOptions]="{ value: formData.jahr, min: 2024, max: 2099, showClearButton: false}"
        [isRequired]="true">
      </dxi-item> -->

      <dxi-item [colSpan]="1" dataField="berechnungsMonatVon" [label]="{ text: 'Von' }" editorType="dxDateBox"
                  [editorOptions]="{ displayFormat: 'monthAndYear', valueChangeEvent: 'keyup', showClearButton: false,
                  calendarOptions:{ maxZoomLevel: 'year', minZoomLevel: 'century' }, onValueChanged: onChangeDatumVon, type: 'date' }">
        <dxi-validation-rule type="required"></dxi-validation-rule>
        @if (formData.berechnungsMonatBis !== null && formData.berechnungsMonatBis !== undefined) {
          <dxi-validation-rule
            type="range" [max]="formData.berechnungsMonatBis !== undefined ? formData.berechnungsMonatBis : null" message="Von-Datum darf nicht nach dem Bis-Datum liegen">
          </dxi-validation-rule>
        }
      </dxi-item>
      <dxi-item [colSpan]="1" dataField="berechnungsMonatBis" [label]="{ text: 'Bis' }" editorType="dxDateBox"
                  [editorOptions]="{ displayFormat: 'monthAndYear', valueChangeEvent: 'keyup', showClearButton: false,
                  calendarOptions:{ maxZoomLevel: 'year', minZoomLevel: 'century'}, value: formData.berechnungsMonatBis, type: 'date'}">
        <dxi-validation-rule type="required"></dxi-validation-rule>
        @if (formData.berechnungsMonatVon !== null && formData.berechnungsMonatVon !== undefined) {
          <dxi-validation-rule
            type="range" [min]="formData.berechnungsMonatVon !== undefined ? formData.berechnungsMonatVon : 0" message="Bis-Datum darf nicht vor dem Von-Datum liegen">
          </dxi-validation-rule>
        }
      </dxi-item>
      <!-- <dxi-item dataField="beitragsArt" [label]="{ text: 'Beitragsart' }" [isRequired]="true" editorType="dxSelectBox" [colSpan]="2"
      [editorOptions]="{ dataSource: beitragsArten, valueExpr: 'key', displayExpr: 'value'}">
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-item>   -->

    <dxi-item [colSpan]="2" dataField="beitragsArten" [label]="{ text: 'Beitragsarten' }" editorType="dxTagBox"
                  [editorOptions]="{
                    dataSource: beitragsArten,
                    valueExpr: 'key',
                    displayExpr: 'value',
                    searchEnabled: true,
                    searchMode: 'startswith',
                    searchTimeout: 200,
                    searchExpr: 'bezeichnung'
                  }">
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-item>
  </dxi-item>
</dx-form>
<div class="message-container">
  @if (!isError && isBerechnet) {
    <span>Die Berechnung wurde erfolgreich abgeschlossen</span>
  }
  @if (isError) {
    <span class="error-container">{{errorText}}</span>
  }
</div>

<dx-load-panel
  #loadPanel
  shadingColor="rgba(0,0,0,0.4)"
  [visible]= "isLoading"
  [position]="{ of: 'window', at: 'center', my: 'center' }"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="false"
  [hideOnOutsideClick]="false"
  message="Stapelberechung läuft..."
  >
</dx-load-panel>
</div>

<dxi-popup-toolbar-item widget="dxButton" location="after" toolbar="bottom"
        [options]="{ text: 'Berechnung starten', type: 'default', stylingMode: 'contained', icon: 'check', 
        onClick: onClickStart, disabled: !(formData.berechnungsMonatVon !== '' && formData.berechnungsMonatBis !== '') || isError}">
</dxi-popup-toolbar-item>
<dxi-popup-toolbar-item widget="dxButton" location="after" toolbar="bottom"
  [options]="{ text: 'Schließen', type: 'default', stylingMode: 'contained', icon: 'remove', onClick: onClickClose }">
</dxi-popup-toolbar-item>
</dx-popup>